<template>
  <div>
    <az-toolbar>
      <az-back-button slot="actions" :route="{name: 'protocoloSelecionar'}" text="Voltar para seleção"></az-back-button>
      <az-search id="ajuste-busca"
                 slot="simpleSearch"
                 ref="campoBuscaLicitacao"
                 :filter="filtrosAtivos"
                 @advanced-search="eventoBuscaAvancada"
                 @simple-search="eventoBuscaSimples"
                 @clear="eventoLimpar"
                 @remove-filter="eventoRemoverFiltro"
                 :simple-search-placeholder="textoPesquisa">
        <az-search-item slot="search-items">
          <v-text-field v-model="filtrosInterno.fornecedor.value" label="Fornecedor"
                        placeholder="Ex. Razão social fornecedor"></v-text-field>
        </az-search-item>
        <az-search-item slot="search-items">
          <v-text-field v-model="filtrosInterno.processo.value" label="Número do Processo"
                        placeholder="Ex. 000.001/2023"></v-text-field>
        </az-search-item>
        <az-search-item slot="search-items" v-if="tipo === 'PROTOCOLO_DOCUMENTO'">
          <v-text-field v-model="filtrosInterno.protocolo.value" label="Protocolo"
                        placeholder="Ex. 0000102020"></v-text-field>
        </az-search-item>
        <az-search-item slot="search-items">
          <v-text-field v-model="filtrosInterno.numeroHash.value" label="Hash"
                        placeholder="Ex. a3763becc21adee"></v-text-field>
        </az-search-item>
      </az-search>
    </az-toolbar>
    <protocolo-busca-tabela :itens="itens" :paginas="paginas" :total-itens="totalItens"
                            :paginacao="$store.state.licitacaoBusca.paginacao"
                            @paginar="eventoPaginar"
                            @visualizar="eventoVisualizar"
    />
  </div>
</template>

<script>
import _ from "lodash";
import {filters} from "@azinformatica/loki";
import {actionTypes, mutationTypes} from "@/commons/constants";
import {mapActions} from "vuex";
import ProtocoloBuscaTabela from "@/views/licitacao/detalhe/orgao/protocolos/ProtocoloBuscaTabela.vue";

export default {
  name: "ProtocoloBusca",
  components: {ProtocoloBuscaTabela},
  data() {
    return {
      filtrosInterno: _.cloneDeep(this.$store.state.protocoloBusca.filtros),
      itens: [],
      paginas: 0,
      totalItens: 0,
      tipo: 'PROTOCOLO_DOCUMENTO',
      textoPesquisa: 'Pesquise por fornecedor, processo, protocolo ou hash'
    }
  },
  computed: {
    filtrosAtivos() {
      const filtros = _.cloneDeep(this.$store.state.protocoloBusca.filtros)
      const filtrosAtivos = {}
      for (let [chave, val] of Object.entries(filtros)) {
        if (filtros[chave].value) {
          val.valueTruncated = filters.azClipText(val.value, 10)
          filtrosAtivos[chave] = val
        }
      }
      return filtrosAtivos
    },
  },
  async mounted() {
    this.setarDados()
    this.forcarExibirFiltrosAvancados()
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_PROTOCOLOS,
    ]),
    setarDados(){
      if (this.$route.params.tipo) {
        this.tipo = this.$route.params.tipo
        if(this.tipo !== 'PROTOCOLO_DOCUMENTO'){
          this.textoPesquisa = 'Pesquise por fornecedor, processo ou hash'
        }
      }
    },
    async buscar() {
      this.$store.commit(mutationTypes.SET_FILTROS_BUSCA_PROTOCOLOS, _.cloneDeep(this.filtrosInterno))
      this.setMensagemLoading('Carregando Protocolos...')
      const resultado = await this.buscarProtocolos(this.tipo)
      if (resultado.totalElements > 0) {
        this.itens = resultado.items
        this.paginas = resultado.totalPages
        this.totalItens = resultado.totalElements
      } else {
        this.itens = []
        this.paginas = 0
        this.totalItens = 0
      }
    },
    eventoBuscaAvancada() {
      this.buscar()
    },
    eventoBuscaSimples(valor) {
      this.filtrosInterno.pesquisa.value = valor
      this.buscar()
    },
    eventoLimpar() {
      this.$store.commit(mutationTypes.LIMPAR_FILTROS_BUSCA_PROTOCOLO)
      this.filtrosInterno = _.cloneDeep(this.$store.state.protocoloBusca.filtros)
      this.buscar()
    },
    eventoRemoverFiltro(propriedade) {
      if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
        this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
      }
      this.buscar()
    },
    forcarExibirFiltrosAvancados() {
      const componenteBusca = this.$refs.campoBuscaLicitacao
      componenteBusca.hasAdvancedSearchItems = true
    },
    eventoPaginar(paginacao) {
      this.$store.commit(mutationTypes.SET_PAGINACAO_BUSCA_PROTOCOLOS, paginacao)
      this.buscar()
    },
    eventoVisualizar(item) {
      this.$router.push({name: 'protocoloVisualizar', params: { id: item.id, tipo: item.tipo}})
    },
  }
}
</script>

<style scoped>

</style>